module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0758.a305c851.jpg";